<div class="otp">
  <input type="tel" maxlength="6" [(ngModel)]="otpCode"  placeholder="000000" #otpinput name="otp-code" autocomplete="one-time-code" />
  @if(otpCode().length) {
    <button (click)="clearCode()" class="clear"><ion-icon name="close-circle"></ion-icon></button>
  }
  <div class="loader" [class.hidden]="!showLoading()">
    <ion-spinner color="accent" name="crescent"></ion-spinner>
  </div>
</div>